import { MessageBar } from "@shared/EDS/components/MessageBar";
import { NotificationList } from "@opstel/dialogs/InstanceDialog/NotificationList.tsx";
import { KapiNotification } from "@opstel/query/models/kapiNotification.ts";

interface ConfirmLoadPendingInstanceDialogContentProps {
  readonly notifications: KapiNotification[];
}

export function ConfirmLoadPendingInstanceDialogContent({
  notifications,
}: ConfirmLoadPendingInstanceDialogContentProps): React.JSX.Element {
  return (
    <>
      <MessageBar messageBarType="warning">
        Het geselecteerde plan bevat problemen. Treinen of inzetten kunnen verwijderd zijn.
      </MessageBar>
      <div className="flex flex-col gap-l">
        <NotificationList notifications={notifications} />
      </div>
    </>
  );
}
